module.exports = __webpack_public_path__ + "img/1f955.8194e18.svg";